import { FC } from 'react';
import { WarningMessage } from './Wrapper';

type CollapseTargetProps = {
  variant: 'danger' | 'warning';
  count?: number;
};

const CollapseTarget: FC<CollapseTargetProps> = ({ count = 0, variant }) => {
  const title = `${count} ${variant === 'danger' ? 'errors' : 'warnings'}`;

  return (
    <WarningMessage variant={variant} position="left" isIcon={true} isCollapse={true}>
      <div>
        <p>{title}</p>
        <span>Read more</span>
      </div>
    </WarningMessage>
  );
};

export default CollapseTarget;
